import { render, staticRenderFns } from "./resolveEditadmin.vue?vue&type=template&id=c08684f2"
import script from "./resolveEditadmin.vue?vue&type=script&lang=js"
export * from "./resolveEditadmin.vue?vue&type=script&lang=js"
import style0 from "./resolveEditadmin.vue?vue&type=style&index=0&id=c08684f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports